import React from "react";

const InputIcon = ({
  icon,
  type,
  placeholder,
  onChange,
  isInvalid,
  onFocus,
  name,
  value,
  disabled,
  label,
  prefix,
}) => {
  return (
    <div>
      {label && <p className="mb-1.5 text-xs text-monochrome-400">{label}</p>}
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 flex items-center pl-3">
          <img src={icon} alt="icon" className="h-4 w-4" />
        </div>
        <div className="pointer-events-none absolute inset-y-0 flex items-center pl-10">
          <p className="text-monochrome-300">{prefix}</p>
        </div>
        <input
          type={type ?? "text"}
          id="default-search"
          className={`form-input ${isInvalid && "!border-danger"} block h-12 w-full ${prefix ? "pl-20" : "pl-10"} disabled:text-monochrome-300`}
          onChange={onChange}
          name={name}
          onFocus={onFocus}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          required
        />
      </div>
    </div>
  );
};

export default InputIcon;
